import React, {useCallback, useEffect, useMemo, useState} from "react";
import ReportingExploreNav from "../../../nav/ReportingExploreNav";
import {getUsersEducation, getUsersExperience} from "../../../../service/queryService";
import TreeGrid from "../../../grid/TreeGrid";
import {SelectPicker} from "rsuite";

const style = {
    justifyContent: 'left',
    marginBottom: '10px',
    marginLeft: '10px',
    width: '200px',
};

const defaultExploreColumns = [
    {
        key: 'value',
        label: '--',
    },
];

const sortByValue = (a, b) => {
    if (a.value < b.value) return -1;
    if (a.value > b.value) return 1;
    return 0;
};

const sortByCompany = (response) => {
    const buckets = {};
    // layer the data with a unique layer-element number to avoid duplicate key problems in the grid
    let companyNum = 1;
    let personTypeNum = 1;
    response.forEach((experience) => {
        if (buckets[experience.company] === undefined) {
            buckets[experience.company] = [];
        }
        buckets[experience.company].push({id: `2-${personTypeNum}`, value: `${experience.lastName} ${experience.firstName}`});
        personTypeNum++;
    });
    const dataSet = [];
    Object.keys(buckets).sort().forEach((bucket) => {
        dataSet.push({
            id: `1-${companyNum}`,
            value: bucket,
            children: buckets[bucket].sort((a,b) => sortByValue(a, b)),
        })
        companyNum++;
    });

    return dataSet;
};

const sortByInstitution = (response) => {
    const buckets = {};
    // layer the data with a unique layer-element number to avoid duplicate key problems in the grid
    let institutionNum = 1;
    let degreeTypeNum = 1;
    let personTypeNum = 1;
    response.forEach((degree) => {
        if (buckets[degree.institution] === undefined) {
            buckets[degree.institution] = [];
        }
        let subBucket = buckets[degree.institution].find((d) => d.value === degree.degreeType);
        if (subBucket === undefined) {
            buckets[degree.institution].push({id: `2-${degreeTypeNum}`, value: degree.degreeType, children: []});
            degreeTypeNum++;
            subBucket = buckets[degree.institution].find((d) => d.value === degree.degreeType);
        }
        subBucket.children.push({id: `3-${personTypeNum}`, value: `${degree.lastName} ${degree.firstName}`});
        personTypeNum++;
    });
    const dataSet = [];
    Object.keys(buckets).sort().forEach((bucket) => {
        dataSet.push({
            id: `1-${institutionNum}`,
            value: bucket,
            children: buckets[bucket].sort((a,b) => sortByValue(a, b)),
        })
        institutionNum++;
    });

    return dataSet;
};

const soryByDegreeType = (response) => {
    const buckets = {};
    // layer the data with a unique layer-element number to avoid duplicate key problems in the grid
    let institutionNum = 1;
    let degreeTypeNum = 1;
    let personTypeNum = 1;
    response.forEach((degree) => {
        if (buckets[degree.degreeType] === undefined) {
            buckets[degree.degreeType] = [];
        }
        let subBucket = buckets[degree.degreeType].find((d) => d.value === degree.institution);
        if (subBucket === undefined) {
            buckets[degree.degreeType].push({id: `2-${institutionNum}`, value: degree.institution, children: []});
            institutionNum++;
            subBucket = buckets[degree.degreeType].find((d) => d.value === degree.institution);
        }
       subBucket.children.push({id: `3-${personTypeNum}`, value: `${degree.lastName} ${degree.firstName}`});
        personTypeNum++;
    });
    const dataSet = [];
    Object.keys(buckets).sort().forEach((bucket) => {
        dataSet.push({
            id: `1-${degreeTypeNum}`,
            value: bucket,
            children: buckets[bucket].sort((a,b) => sortByValue(a, b)),
        })
        degreeTypeNum++;
    });

    return dataSet;
};

const sortByMajor = (response) => {
    const buckets = {};
    // layer the data with a unique layer-element number to avoid duplicate key problems in the grid
    let degreeTypeNum = 1;
    let majorTypeNum = 1;
    let personTypeNum = 1;
    response.forEach((degree) => {
        if (buckets[degree.major] === undefined) {
            buckets[degree.major] = [];
        }
        let subBucket = buckets[degree.major].find((d) => d.value === degree.degreeType);
        if (subBucket === undefined) {
            buckets[degree.major].push({id: `2-${degreeTypeNum}`, value: degree.degreeType, children: []});
            degreeTypeNum++;
            subBucket = buckets[degree.major].find((d) => d.value === degree.degreeType);
        }
        // dedupe people with multiple of the same major/degree type
        if (subBucket.children.find((person) => person.value === `${degree.lastName} ${degree.firstName}`) === undefined) {
            subBucket.children.push({id: `3-${personTypeNum}`, value: `${degree.lastName} ${degree.firstName}`});
            personTypeNum++;
        }
    });
    const dataSet = [];
    Object.keys(buckets).sort().forEach((bucket) => {
        dataSet.push({
            id: `1-${majorTypeNum}`,
            value: bucket,
            children: buckets[bucket].sort((a,b) => sortByValue(a, b)),
        })
        majorTypeNum++;
    });

    return dataSet;
};

const Explore = () => {
    const [active, setActive] = useState('education');
    const [unsortedEducationData, setUnsortedEducationData] = useState([]);
    const [education, setEducation] = useState([]);
    const [experience, setExperience] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selection, setSelection] = useState('Institution');

    const filterByTypes = ['Institution', 'Degree Type', 'Major'].map((selection) => ({label: selection, value: selection}));

    // fetch and format the data into a tree format for the grids
    useEffect(() => {
        setLoading(true);
        getUsersEducation().then((response) => {
            setUnsortedEducationData(response);
            setEducation(sortByInstitution(response));
            setLoading(false);
        });
        getUsersExperience().then((response) => {
            setExperience(sortByCompany(response));
        });
    }, []);

    const filterChange = useCallback((selection) => {
        setSelection(selection);
        switch(selection) {
            case 'Institution':
                setEducation(sortByInstitution(unsortedEducationData))
                break;
            case 'Degree Type':
                setEducation(soryByDegreeType(unsortedEducationData));
                break;
            case 'Major':
                setEducation(sortByMajor(unsortedEducationData));
                break;
            default:
                break;
        }
    }, [unsortedEducationData]);

    const renderPage = useMemo(() => {
        switch (active) {
            case 'education':
                 defaultExploreColumns[0].label = selection
                return (
                    <>
                        Sort By: <SelectPicker data={filterByTypes} style={style} onChange={filterChange} value={selection} />
                        <TreeGrid
                            loading={loading}
                            rowKey="id"
                            data={education}
                            columns={defaultExploreColumns}
                        />
                    </>
                );
            case 'experience':
                defaultExploreColumns[0].label = 'Company'
                return <TreeGrid
                    loading={loading}
                    rowKey="id"
                    data={experience}
                    columns={defaultExploreColumns}
                />;
            default:
                break; //do nothing
        }
    }, [active, education, experience, filterByTypes, filterChange, loading, selection]);

    return useMemo(() =>{
        return (
            <div>
                <ReportingExploreNav appearance="tabs" active={active} onSelect={setActive} />
                {renderPage}
            </div>
        );
    }, [active, renderPage]);
};

export default Explore;